import { Switch } from '@payfit/midnight/dist/Switch';
import React, { ReactNode, useEffect } from 'react';

import { classNames } from '../../utils/style';
import { useParams } from '../../utils/useParams';
import { toBoolean } from '../../utils/toBoolean';

export interface ExtraToggleProps {
  name: string;
  children: ReactNode;
  initialValue?: boolean;
  isDisabled?: boolean;
  offerInclude?: boolean;
  className?: string;
  includedLabel?: string;
}

export const ExtraToggle = ({
  name,
  children,
  initialValue,
  isDisabled = false,
  offerInclude = false,
  className,
  includedLabel = 'Inclus',
}: ExtraToggleProps) => {
  const [params, setParams] = useParams();

  useEffect(() => {
    if (
      initialValue &&
      !params?.[name] &&
      initialValue !== toBoolean(params?.[name])
    )
      setParams(name, initialValue.toString());
  }, [initialValue, name, params, setParams]);

  return (
    <div
      className={classNames(
        'ExtraToggle',
        toBoolean(params?.[name]) && 'checked',
        'flex',
        className,
      )}
    >
      <div className={classNames('ExtraToggle__content', 'w-full mr-[5px]')}>
        {children}
      </div>
      {!offerInclude ? (
        <Switch
          label=""
          hideLabel={true}
          isDisabled={isDisabled}
          initialValue={initialValue}
          onChange={(value: boolean) => {
            setParams(name, value.toString());
          }}
          value={toBoolean(params?.[name])}
        />
      ) : (
        <div
          className={classNames(
            'labelIncluded text-mint-101 flex',
            'uppercase text-14 items-start',
          )}
        >
          {includedLabel}&nbsp;
          <svg
            className="logoIncluded mt-4 ml-8"
            width="10"
            height="14"
            viewBox="0 0 10 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.332031 5.17839C0.332031 2.60505 2.42536 0.511719 4.9987 0.511719C7.57203 0.511719 9.66536 2.60505 9.66536 5.17839C9.66536 7.95839 6.7187 11.7917 5.50536 13.2517C5.2387 13.5717 4.75203 13.5717 4.48536 13.2517C3.2787 11.7917 0.332031 7.95839 0.332031 5.17839ZM4.45203 8.03839L7.87203 4.61839C8.13203 4.35839 8.13203 3.93839 7.8787 3.67172C7.6187 3.41172 7.19203 3.41172 6.93203 3.67172L3.98536 6.61839L3.0787 5.71172C2.8187 5.45172 2.39203 5.45172 2.13203 5.71172C1.87203 5.97172 1.87203 6.39839 2.13203 6.65839L3.51203 8.03839C3.77203 8.29839 4.19203 8.29839 4.45203 8.03839Z"
              fill="#01C195"
            />
          </svg>
        </div>
      )}
    </div>
  );
};
